import b from 'b_';
import { SimpleCallback } from 'platform-components/common';
import React, { ReactNode } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import './calendar-plan-showcase__animated-view.scss';

const TRANSITION_TIMEOUT_MS = 200;

interface Props {
    children: ReactNode;
    animationKey: string;
    onAnimationEntering?: SimpleCallback;
}

export const CalendarPlanShowcaseAnimatedView = ({ children, animationKey, onAnimationEntering }: Props) => (
    <div className={b('calendar-plan-showcase', 'animated-view')}>
        {/* Set component={null} to avoid a wrapping extra <div> element */}
        <TransitionGroup component={null}>
            <CSSTransition
                classNames={b('calendar-plan-showcase', 'animated-view_state')}
                key={animationKey}
                onEntering={onAnimationEntering}
                timeout={TRANSITION_TIMEOUT_MS}
            >
                <div>{children}</div>
            </CSSTransition>
        </TransitionGroup>
    </div>
);
